export const emptySearchMessageQuarantine = 'No Logs Found.';
